module.exports = __webpack_public_path__ + "static/media/8.2cc5abd0.jpg";